import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { Gstr2BResponse, GstrReconciliation, SuppliersReport } from '../../models/gstr-2b-response.model';

@Component({
  selector: 'app-reconciliation-table',
  templateUrl: './reconciliation-table.component.html',
  styleUrl: './reconciliation-table.component.scss'
})
export class ReconciliationTableComponent implements OnChanges  {
  @Input() input: Gstr2BResponse | undefined;
  reconciliation: GstrReconciliation | undefined
  suppliers_report: SuppliersReport | undefined;

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['input']?.currentValue) {
      this.reconciliation = this.getReconciliation();
      this.suppliers_report = this.getSuppliersReport();
    }
  }

  getReconciliation(){
    return this.input?.stats["gstr_reconciliation"];
  }

  getSuppliersReport() {
    return this.input?.suppliersReport;
  }

}
